<template>
  <a
    :class="classObject"
    :href="link.to"
    v-if="isExternalLink"
    :exact="link.exact"
    :aria-label="link.text"
  >
    <span class="c-navigation-link__icon">
      <icon
        v-if="link.icon"
        :name="link.icon"
        width="18"
        height="18"
        :color="link.iconColor"
        :fill="link.iconFill"
      ></icon>
    </span>
    <span class="c-navigation-link__text"
      >{{ link.text }}
      </span
    ></a
  >
  <router-link
    v-else
    :class="classObject"
    :to="link.to"
    @click.native="$emit('click')"
    :exact="link.exact"
    :aria-label="link.text"
  >
    <!-- Link icon -->
    <span class="c-navigation-link__icon">
      <icon
        v-if="link.icon"
        :name="link.icon"
        width="18"
        height="18"
        :color="link.iconColor"
        :fill="link.iconFill"
      ></icon>
    </span>


    <!-- Link text -->
    <span class="c-navigation-link__text"
      >{{ link.text }}
      <span v-if="link.viewAll" class="view-all">View all</span></span
    >

    <!-- Dropdown arrow -->
    <span
      v-if="link.children"
      class="c-navigation-link__dropdown"
      @click.stop.prevent="onClickDropdown"
    >
      <icon name="drop-arrow" width="8" height="8"></icon>
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'app-navigation-link',
  data() {
    return {
      blue: '#0072CE',
    };
  },

  props: {
    link: Object,
  },

  computed: {
    classObject() {
      return {
        'c-navigation-link': true,
        'is-open': this.link.isOpen,
      };
    },
    isExternalLink() {
      const pattern = /http(s{0,1})\:\/\/[a-zA-Z\.-\/]+/gm;
      const match = this.link.to.match(pattern);
      return match && match.length > 0;
    },
  },

  methods: {
    onClickDropdown() {
      this.$emit('dropdown-click');
    },
  },
};
</script>

<style lang="scss">
.c-navigation-link {
  color: $colour-nhs-white;
  display: block;
  padding: 1em;
  text-decoration: none;
  font-size: 18px;
  min-height: 55px;
  position: relative;

  .view-all {
    float: right;
    font-size: 14px;
    color: $colour-cactus-core-green;
    line-height: 16px;
    margin-top: 2px;
  }

  &__text {
    visibility: hidden;
    opacity: 0;
    transition: all 0.3s 0.3s;
    transition-delay: 0.2s;
    display: block;
    margin-left: 55px;
  }

  &__icon {
    transform: translateX(281px);
    transition: all 0.3s 0.3s;
    transition-delay: 0.3s;

    width: 55px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  &__icon svg {
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__dropdown {
    visibility: visible;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 55px;
    padding-left: 23.5px;
    padding-top: 18px;
    opacity: 1;
    transition: opacity 1s ease;
    transition-delay: 0.3s;

    svg {
      transition: transform 0.4s 0s;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.2);
    }
  }

  &.is-open > &__dropdown > svg {
    transform: rotate(-180deg);
  }

  .c-navigation.is-closed & &__dropdown {
    visibility: hidden;
    opacity: 0;
    transition: opacity 1s ease;
  }
  .c-navigation.is-open & &__icon {
    transform: translateX(0);
    transition-delay: 0.1s;
  }

  .c-navigation.is-open & &__text {
    visibility: visible;
    opacity: 1;
    transition-delay: 0.3s;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  &.is-active {
    // background: rgba(0, 0, 0, 0.25);
  }
}
</style>
